import html2canvas from "html2canvas";

/**
 * Converts a div element into a Base64 PNG.
 * 
 * @param {string} divId - The id of the div to capture.
 * @param {number} scale - Scale for higher resolution (default: 2).
 * @returns {Promise<string|null>} Base64 PNG string or null if div not found.
 */
export default async function htmlConvert(divId, scale = 2) {
    const element = document.getElementById(divId);
    if (!element) return null;

    try {
        const canvas = await html2canvas(element, {
            scale,
            backgroundColor: null, // transparent background
        });
        return canvas.toDataURL("image/png");
    } catch (error) {
        console.error(`Error capturing ${divId}:`, error);
        return null;
    }
}
